import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, firstValueFrom } from 'rxjs';
import { ModulTema } from './modul-tema';
import { Szinmod, szinmodBeallit } from './szinmod';

export interface FelhasznaloBeallitas {
  /** A felhasználó választott témája modulonként; ami nincs benne, ott az admin alapértelmezése. */
  tema: Record<string, ModulTema>;
  /** A menü és a fejléc színe a SULINFORM Fókuszában; null = a rendszer szerint. */
  szinmod: Szinmod | null;
}

const TAR = 'felhasznaloBeallitas';

/**
 *  A FELHASZNÁLÓ SAJÁT BEÁLLÍTÁSAI (backend/felhasznalo-beallitas.js) – a Beállítások oldal írja,
 *  az app.component a téma meghatározásához olvassa (a felhasználó választása > a régi
 *  kipróbálás > az admin alapértelmezése). Indításkor a böngészőben tárolt másolat azonnal él
 *  (nincs villanás), a kiszolgálóról frissül.
 */
@Injectable({ providedIn: 'root' })
export class FelhasznaloBeallitasService {
  adat: FelhasznaloBeallitas = { tema: {}, szinmod: null };
  /** Változott (betöltés vagy mentés) – a keret ilyenkor újraszámolja a témát. */
  readonly valtozas = new Subject<void>();
  private felhasznalo = '';

  constructor(private http: HttpClient) {
    try {
      const v = JSON.parse(localStorage.getItem(TAR) || 'null');
      if (v && typeof v === 'object') this.adat = { tema: v.tema || {}, szinmod: v.szinmod || null };
    } catch { /* nincs tárolt másolat */ }
  }

  /** A modulra választott téma (vagy null: az intézményi alapértelmezés él). */
  tema(mod: string): ModulTema | null {
    const t = this.adat.tema?.[mod];
    return t === 'klasszikus' || t === 'fokusz' ? t : null;
  }

  private tarol() {
    try { localStorage.setItem(TAR, JSON.stringify(this.adat)); } catch { /* privát ablak */ }
    //  A szín a szinmod.ts-ben él (a Fókusz-sáv választója is onnan olvas).
    szinmodBeallit(this.adat.szinmod || 'rendszer');
  }

  /** Betöltés a kiszolgálóról (a keret hívja, ha ismert a felhasználó). */
  async betolt(felhasznalo: string) {
    this.felhasznalo = String(felhasznalo || '').trim().toLowerCase();
    if (!this.felhasznalo) return;
    try {
      const r: any = await firstValueFrom(this.http.get(`/api/felhasznalo-beallitas/${encodeURIComponent(this.felhasznalo)}`));
      this.adat = { tema: r?.tema || {}, szinmod: r?.szinmod || null };
      this.tarol();
      this.valtozas.next();
    } catch { /* a tárolt másolat marad */ }
  }

  /** Részleges mentés: { tema: { MODUL: 'fokusz' | 'klasszikus' | null } } és/vagy { szinmod }. */
  async ment(valtozas: { tema?: Record<string, ModulTema | null>; szinmod?: Szinmod | null }) {
    //  Azonnal érvényes (a felület nem vár a kiszolgálóra), utána a kiszolgáló válasza a mérvadó.
    if (valtozas.tema) {
      for (const [k, v] of Object.entries(valtozas.tema)) {
        if (v) this.adat.tema[k] = v; else delete this.adat.tema[k];
      }
    }
    if (Object.prototype.hasOwnProperty.call(valtozas, 'szinmod')) this.adat.szinmod = valtozas.szinmod || null;
    this.tarol();
    this.valtozas.next();
    if (!this.felhasznalo) return;
    const r: any = await firstValueFrom(this.http.put(`/api/felhasznalo-beallitas/${encodeURIComponent(this.felhasznalo)}`, valtozas));
    this.adat = { tema: r?.tema || {}, szinmod: r?.szinmod || null };
    this.tarol();
    this.valtozas.next();
  }
}
